import { Component } from '@angular/core';
import { IPatientTableItem } from 'src/app/interfaces/PDQ/IPDQResponse';
import { PDQService } from 'src/app/services/pdq.service';
import { SwalToastService } from 'src/app/services/swal.service';

@Component({
  selector: 'app-pdqiti21',
  templateUrl: './pdqiti21.component.html',
  styleUrls: ['./pdqiti21.component.css'],
  standalone: false,
})
export class Pdqiti21Component {
  ip: string = '192.67.249.3';
  port: number = 8800;

  value =
    'MSH|^~\\&|FORTH_CONSUMER|FORTH|ICS|FORTH|20250613103051||QBP^Q22^QBP_Q21|0a563edbf50d4e96a77b10d573e24fb4|P|2.5||||||UNICODE UTF-8\r' +
    'QPD|IHE PDQ Query|20250613103051|@PID.5.1.1^MOORE~@PID.11.1.1^10 PINETREE\r' +
    'RCP|I';

  result = '-';
  resultRows = 1;

  patientsData: IPatientTableItem[] = [];

  constructor(
    private readonly pdqservice: PDQService,
    private readonly swalToastService: SwalToastService
  ) {}

  pdqiti21() {
    this.pdqservice.pdqiti21(this.ip, this.port, this.value).subscribe({
      next: (response) => {
        this.result = response.received || '-';
        this.patientsData = this.parseToPatientTable(this.result);
        const lineCount = (this.result.match(/\r/g) || []).length + 1;
        this.resultRows = Math.min(Math.max(lineCount, 1), 20);
      },
      error: (err) => {
        this.swalToastService.toastError('Unable to get PDQ ITI-21');
        console.error('Error sending PDQ ITI-21:', err);
      },
    });
  }

  parseToPatientTable(hl7: string): IPatientTableItem[] {
    const segments = hl7.split('\r');
    const patients: IPatientTableItem[] = [];

    for (const segment of segments) {
      if (!segment.startsWith('PID')) continue;

      const fields = segment.split('|');

      // Identifiers (PID-3)
      const identifiers = fields[3]
        ? fields[3]
            .split('~')
            .map((id) => id.trim())
            .join(', ')
        : '';

      // Name (PID-5)
      const nameParts = fields[5] ? fields[5].split('^') : [];
      const name = `${nameParts[1] || ''} ${nameParts[0] || ''}`.trim(); // "Given Family"

      // BirthDate (PID-7)
      const birthDate = fields[7] || '';

      // Gender (PID-8)
      const gender =
        fields[8] === 'M' ? 'Male' : fields[8] === 'F' ? 'Female' : 'Unknown';

      // Address (PID-11)
      const addrParts = fields[11] ? fields[11].split('^') : [];
      const address = [
        addrParts[0] || '', // Street
        addrParts[2] || '', // City
        addrParts[3] || '', // State
        addrParts[4] || '', // Postal Code
        addrParts[5] || '', // Country
      ]
        .filter(Boolean)
        .join(', ');

      const link = '';
      patients.push({
        name,
        gender,
        birthDate,
        identifiers,
        address,
        link,
      });
    }

    return patients;
  }
}
